module.exports = "/fonts/Raleway-SemiBold.ttf?17ba6410cbc694808961a988fd4426de";